import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["member", "size", "className", "sx"],
    _excluded2 = ["member", "size", "hideMessaging", "className", "disabledPopover", "clickAwayMouseEvent", "popoverZIndex"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import PersonIcon from '@mui/icons-material/Person';
import { Avatar as AvatarIcon, css, styled } from '@mui/material';
import { absurd } from 'fp-ts/function';
import { ProfilePopover } from '../profile-popover';
import { jsx as _jsx } from "react/jsx-runtime";
var SizedAvatarIcon = styled(AvatarIcon)(function (_ref) {
  var size = _ref.size,
      theme = _ref.theme;

  if (size === 'xsmall') {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      width: ", ";\n      height: ", ";\n      font-size: 12px;\n    "])), theme.spacing(3), theme.spacing(3));
  }

  if (size === 'small') {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      width: ", ";\n      height: ", ";\n      font-size: ", ";\n    "])), theme.spacing(5), theme.spacing(5), theme.spacing(3));
  }

  if (size === 'medium') {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      width: ", ";\n      height: ", ";\n      font-size: ", ";\n    "])), theme.spacing(8), theme.spacing(8), theme.spacing(4));
  }

  if (size === 'large') {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      width: ", ";\n      height: ", ";\n      font-size: ", ";\n    "])), theme.spacing(16), theme.spacing(16), theme.spacing(8));
  }

  return absurd(size);
});

var AvatarImage = function AvatarImage(_ref2) {
  var member = _ref2.member,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'small' : _ref2$size,
      className = _ref2.className,
      sx = _ref2.sx,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(SizedAvatarIcon, _objectSpread(_objectSpread({
    sx: mergeSxProps({
      backgroundColor: function backgroundColor(t) {
        return t.palette.neutral.light;
      },
      color: function color(t) {
        return t.palette.common.white;
      }
    }, sx),
    size: size,
    src: member.avatarUrl || undefined,
    alt: member.name
  }, rest), {}, {
    "data-element": "SizedAvatarIcon",
    "data-component": "AvatarImage",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(PersonIcon, {
      sx: {
        width: '90%',
        height: '90%',
        pb: '8%'
      },
      "data-element": "PersonIcon",
      "data-component": "AvatarImage",
      "data-source-file": "index.tsx"
    })
  }));
};

export var Avatar = function Avatar(_ref3) {
  var member = _ref3.member,
      size = _ref3.size,
      _ref3$hideMessaging = _ref3.hideMessaging,
      hideMessaging = _ref3$hideMessaging === void 0 ? false : _ref3$hideMessaging,
      className = _ref3.className,
      _ref3$disabledPopover = _ref3.disabledPopover,
      disabledPopover = _ref3$disabledPopover === void 0 ? false : _ref3$disabledPopover,
      clickAwayMouseEvent = _ref3.clickAwayMouseEvent,
      popoverZIndex = _ref3.popoverZIndex,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  return !disabledPopover ? /*#__PURE__*/_jsx(ProfilePopover, {
    id: member.id,
    popoverZIndex: popoverZIndex,
    clickAwayMouseEvent: clickAwayMouseEvent,
    hideMessaging: hideMessaging,
    children: /*#__PURE__*/_jsx(AvatarImage, _objectSpread(_objectSpread({
      member: member,
      size: size
    }, rest), {}, {
      children: /*#__PURE__*/_jsx(PersonIcon, {
        fontSize: "inherit"
      })
    }))
  }) : /*#__PURE__*/_jsx(AvatarImage, _objectSpread(_objectSpread({
    className: className,
    member: member,
    size: size
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(PersonIcon, {
      fontSize: "inherit"
    })
  }));
};